const FilesSvg: React.FC<{ color?: string }> = ({ color }) => {
  return (
    <svg
      width="34"
      height="33"
      viewBox="0 0 34 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.48 25.9716C25.7608 25.6946 25.9211 25.3182 25.9264 24.9239V11.9939H26.9264V24.9039C26.9264 25.5669 26.663 26.2028 26.1941 26.6717C25.7253 27.1405 25.0894 27.4039 24.4264 27.4039H9.42638C8.76679 27.4039 8.13392 27.1433 7.66565 26.6787C7.19738 26.2142 6.93166 25.5835 6.92638 24.9239V7.92388C6.92374 7.5939 6.98646 7.26666 7.11091 6.96103C7.23536 6.65541 7.41909 6.37744 7.6515 6.14317C7.88391 5.90891 8.1604 5.72297 8.46503 5.59608C8.76965 5.4692 9.09639 5.40387 9.42638 5.40388H21.5464L26.9264 10.8239H23.6664C23.0952 10.8212 22.5484 10.5925 22.1455 10.1877C21.7426 9.78292 21.5164 9.23502 21.5164 8.66389V6.40388H9.42638C9.2277 6.40387 9.031 6.44332 8.8477 6.51995C8.66439 6.59658 8.49814 6.70886 8.35859 6.85027C8.21903 6.99169 8.10896 7.15941 8.03477 7.34372C7.96057 7.52802 7.92373 7.72523 7.92638 7.92388V24.9239C7.93164 25.3182 8.09199 25.6946 8.37273 25.9716C8.65347 26.2486 9.032 26.4039 9.42638 26.4039H24.4264C24.8208 26.4039 25.1993 26.2486 25.48 25.9716ZM22.1663 14.7939V15.5139H21.1663V14.7939C21.1637 14.1008 20.8865 13.4369 20.3954 12.9477C19.9043 12.4585 19.2394 12.1839 18.5463 12.1839H17.6363V20.4039C17.5722 21.0746 17.2623 21.6979 16.7663 22.1539C16.2833 22.658 15.6239 22.9555 14.9263 22.9839C14.4811 22.976 14.0571 22.7927 13.7463 22.4739C13.5671 22.2496 13.4339 21.9921 13.3545 21.7162C13.2751 21.4403 13.2509 21.1514 13.2835 20.8662C13.316 20.5809 13.4045 20.3049 13.544 20.0539C13.6835 19.803 13.8712 19.5821 14.0963 19.4039C14.4084 19.057 14.8155 18.8095 15.2671 18.6922C15.7187 18.5748 16.1948 18.5928 16.6363 18.7439V11.1839H18.5463C19.5047 11.1839 20.4239 11.5639 21.1025 12.2406C21.7811 12.9173 22.1637 13.8355 22.1663 14.7939Z"
        fill={color || "white"}
      />
      {/* <rect
        x="0.8013"
        y="0.278885"
        width="32.25"
        height="32.25"
        stroke="#8B8B8B"
        stroke-width="0.25"
      /> */}
    </svg>
  );
};

export default FilesSvg;
